import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { deleteSupportingDoc } from 'actions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';

class FileContent extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    onDeleteCallback: PropTypes.func,
    item: PropTypes.shape({
      id: PropTypes.string.isRequired,
      localeDescription: PropTypes.string.isRequired,
      originalFileName: PropTypes.string,
      fileName: PropTypes.string
    }).isRequired,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired
    }).isRequired
  };

  static defaultProps = {
    onDeleteCallback: null,
  };

  static onViewSupportingDocument(file) {
    if (file) {
      window.open(`customers/supporting-docs/${ file.id }`, '_blank'); // to open new page
    }
  }

  onDeleteSupportingDocument(file) {
    const { dispatch, onDeleteCallback } = this.props;
    dispatch(deleteSupportingDoc(file.id));

    if (onDeleteCallback) {
      onDeleteCallback();
    }
  }

  render() {
    const { item, intl } = this.props;

    return <div className="row file-content mh-0">
      <div className="col-10 ph-0">
        <p>{item.localeDescription}</p>
        <p className="break-word">{item.originalFileName || item.fileName}</p>
      </div>
      <div className="col-2 ph-0 aside text-right">
        <button className="supporting-doc-delete-button" onClick={ () => this.onDeleteSupportingDocument(item) } type="button" title={ intl.formatMessage({ id: 'supportingDocuments.deleteDocument' }) }>
          <span className="cross fa-layers fa-2x">
            <FontAwesomeIcon icon="circle" className="fa-sm" />
            <span className="fa-xs"><FontAwesomeIcon icon="trash-alt" className="layered-button fa-xs" /></span>
          </span>
        </button>
      </div>
    </div>;
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapDispatchToProps
)(injectIntl(FileContent));
